<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M1.998 15a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h2v-.5a1 1 0 0 1 2 0V2h4v-.5a1 1 0 0 1 2 0V2h2a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1zm0-1h12V5h-2a1 1 0 0 1-2 0h-4a1 1 0 0 1-2 0h-2zm8-2v-2h2v2zm-3 0v-2h2v2zm-3 0v-2h2v2zm6-3V7h2v2zm-3 0V7h2v2zm-3 0V7h2v2z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-callendar',
});
</script>
